import Vuex from 'vuex'
import Vue from 'vue'
import Geral from './geral'
import Ementa from './ementa'
import Busca from './busca'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    geral: Geral,
    ementa: Ementa,
    busca: Busca
  }
})
